import { render, staticRenderFns } from "./payments_report.vue?vue&type=template&id=8b8fab28&"
import script from "./payments_report.vue?vue&type=script&lang=js&"
export * from "./payments_report.vue?vue&type=script&lang=js&"
import style0 from "./payments_report.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports